const comments = [
  {
    id: 1,
    name: '追剧达人小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20portrait%20style%20avatar%2C%20soft%20lighting%20on%20face%2C%20clean%20neutral%20background%2C%20friendly%20expression%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-01-user&orientation=squarish',
    date: '2026年7月28日',
    rating: 5,
    content: '蓝莓影院的更新速度真的快，庆余年第二季刚播完这里就有了全集，画质也很清晰流畅！不用注册就能直接看，追剧体验比那些收费平台还好，已经推荐给身边所有追剧的朋友了。',
  },
  {
    id: 2,
    name: '怀旧剧迷李阿姨',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20style%20avatar%20of%20middle%20aged%20person%2C%20soft%20natural%20lighting%2C%20kind%20expression%2C%20clean%20neutral%20background%2C%20simple%20and%20approachable%20aesthetic&width=80&height=80&seq=avatar-02-user&orientation=squarish',
    date: '2026年7月25日',
    rating: 5,
    content: '太感动了！90年代的经典老剧这里居然都有全集，像《还珠格格》《武林外传》这些以前只能在电视上看到，现在随时随地都能重温。蓝莓影院真是老剧爱好者的宝藏平台。',
  },
  {
    id: 3,
    name: '影视爱好者小王',
    avatar: 'https://readdy.ai/api/search-image?query=Modern%20portrait%20style%20avatar%20of%20young%20person%2C%20natural%20daylight%20illumination%2C%20casual%20and%20friendly%20look%2C%20clean%20minimalist%20background%2C%20contemporary%20headshot%20style&width=80&height=80&seq=avatar-03-user&orientation=squarish',
    date: '2026年7月22日',
    rating: 5,
    content: '剧集分类很全，古装仙侠、都市情感、悬疑推理都有专门的专题，找剧特别方便。而且真的不缓冲，家里网速一般也能流畅看高清，不用下载任何APP，打开网页就能追剧，满分推荐！',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            剧迷热评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            来自追剧爱好者的真实反馈，看看大家怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <div className="font-medium text-sm text-foreground-900 whitespace-nowrap overflow-hidden text-ellipsis">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.date}</div>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: comment.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}